import React from 'react';
import { IconButton, Dialog, DialogTitle, DialogContent, useMediaQuery, Typography } from '@material-ui/core';
import { makeStyles, createStyles, useTheme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import {connect} from 'react-redux';
import { setModalReset } from "../../actions/app";

const useStyles = makeStyles(theme => createStyles({
    dialogContent: {
        color: theme.palette.grey.darkest,
        padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
        [theme.breakpoints.up(`sm`)]: {
            padding: `${theme.spacing(1)}px ${theme.spacing(4)}px ${theme.spacing(2)}px`,
        }
    },
    dialogTitle: {
        padding: `${theme.spacing(5)}px ${theme.spacing(1.5)}px ${theme.spacing(2)}px ${theme.spacing(1.5)}px`,
        [theme.breakpoints.up(`sm`)]: {
            padding: `${theme.spacing(5)}px ${theme.spacing(5)}px ${theme.spacing(2)}px ${theme.spacing(4)}px`
        }
    },
    paper: {
        padding: 0,
        backgroundColor: 'white !important'
    },
    icon: {
        color: 'white',
        position: 'relative'
    },
    iconContainer: {
        position: 'absolute',
        textAlign: 'center',
        width: '60px',
        top: 0,
        transform: 'translateX(-50%)',
        left: '50%',
        zIndex: 2,
        padding: theme.spacing(2),
    },
    iconBackground: {
        fill: theme.palette.primary.main,
        position: 'absolute',
        top: '1px',
        left: 0
    },
    title: {
        marginBottom: 0
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        zIndex: 2,
        top: theme.spacing(1),
        color: theme.palette.grey[600],
    },
}));

const Modal = function({
    id,
    title = '',
    subtitle = '',
    onClose = () => {},
    maxWidth = 'xs',
    fullScreen = null,
    fullWidth = true,
    variant = 'plain',
    modal,
    setModalReset,
    children,
    PaperProps = {},
    closeable = true
}) {
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'));
    const classes = useStyles();
    const [previousModal, setPreviousModal] = React.useState(modal);

    const handleClose = () => {
        if (!closeable) {
            return;
        }
        setModalReset();
    };

    React.useEffect(() => {
        if (previousModal === id && modal !== id) {
            onClose();
        }
        setPreviousModal(modal);
        // eslint-disable-next-line
    }, [modal]);

    return (
        <Dialog
            fullScreen={fullScreen ? fullScreen : !smUp}
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={id === modal}
            scroll="body"
            onClose={handleClose}
            id={id}
            PaperProps={{
                className: classes.paper,
                ...PaperProps
            }}
        >

            {closeable && (
                <IconButton size="small" className={`${classes.closeButton} modal-close-icon-button`} aria-label="close" onClick={() => {setModalReset()}}>
                    <CloseIcon />
                </IconButton>
            )}
            <DialogTitle className={classes.dialogTitle}>
                {title}
                {subtitle && (
                    <div style={{marginTop: '10px'}}>
                        <Typography><small>{subtitle}</small></Typography>
                    </div>
                )}
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                {children}
            </DialogContent>
        </Dialog>
    )
};

export default connect(
    (state) => ({
        modal: state.app.modal,
    }), {
        setModalReset
    }
)(Modal);
